import React, {useCallback} from 'react';
import {useStores} from "../../stores";
import {observer} from "mobx-react-lite";
import {
    ApiDropdownFilterComponent,
    DEFAULT
} from "../../components/visualization/api-dropdown-filter/ApiDropdownFilterComponent";
import type {Option, SelectionResult} from "../../components/visualization/api-dropdown-filter/ApiDropdownTypes";
import type {PageResponse} from "../../services/ApiTypes";
import {getSupplierIdHack} from "../../stores/hacks/display.ts";

type Selection = SelectionResult<string>;
type Props = {
    wrapperClassName?: string
    limitTags?: number
}
export const SearchSupplierAutocomplete: React.FC<Props> = observer(({wrapperClassName, limitTags}) => {
    const {p, bagStore, materializedApi} = useStores();

    const selection = bagStore.advanced.filters.s_ids || DEFAULT;
    /**
     * Note: We filter the suppliers by the selected parent suppliers as well
     *  We could consider not filtering the supplier and parent supplier fields together
     */
    const filter = bagStore.advanced.filterQueryParamsSupplier;

    const getOptions = useCallback(
        search => (bagStore.advanced.databagId && bagStore.advanced.ready) ? materializedApi.searchInsightSupplier(bagStore.advanced.databagId, filter, search)
            .then<PageResponse<Option>>(resp => ({
                count: resp.data.length,
                next: '',
                previous: '',
                results: resp.data.map(obj => ({
                    id: obj.s_id,
                    label: obj.s_name,
                    subLabel: getSupplierIdHack(obj),
                    subTotalSpend: Number(obj.total_spend),
                    obj,
                }))
            })) : null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [bagStore.advanced.databagId, bagStore.advanced.ready, filter]
    );

    if (!bagStore.advanced.ready) return <></>;
    return <ApiDropdownFilterComponent
        selection={selection}
        label={p.supplierDataName}
        enableLabelStatus
        getOptions={getOptions}
        showOptionSubLabel={p.p.showSupplierIdInAdvDashboard}
        onSelectionChange={selection => bagStore.advanced.supplierFilterChanged(selection as Selection)}
        buttonProps={{fullWidth: true, sx: {height: '100%'}}}
    />
})
